import React, { useState } from 'react';
import EC from '../../images/ec.jpg';
import Children from '../../images/children.jpg';
import Youth from '../../images/youth.jpg';
import { getPrices, updatePricing } from '../../utils.js';

const Pricing = () => {
	const [selectedEarlyValue, setSelectedEarlyValue] = useState('standard');
	const [selectedChildrenValue, setSelectedChildrenValue] = useState('standard');
	const [selectedYouthValue, setSelectedYouthValue] = useState('standard');

	const handleRadioChange = (event) => {
		let optionIndex = document.getElementById(event.target.name + 'Dropdown').selectedIndex,
			priceElement = document.getElementById(event.target.name + 'Price');

		switch(event.target.name) {
			case 'early':
				setSelectedEarlyValue(event.target.value);
				break;
			case 'children':
				setSelectedChildrenValue(event.target.value);
				break;
			case 'youth':
				setSelectedYouthValue(event.target.value);
				break;
			default:
				break;
		}

		updatePricing(event.target.name, optionIndex, priceElement, event.target.value);
	};

	const handlePriceChange = (event) => {
		let ageLevel = event.target.dataset.level,
			optionIndex = event.target.selectedIndex,
			priceElement = document.getElementById(ageLevel + 'Price'),
			subLevel = document.querySelector('input[type="radio"].' + ageLevel + ':checked').value;

		updatePricing(ageLevel, optionIndex, priceElement, subLevel);
	};

	return (
		<div className="tiles">
			<div className="tile">
				<div className="image full">
					<img src={EC} alt="group of young children in Sunday school classroom" />
				</div>
				<div className="content">
					<h3>Early Childhood</h3>
					<p>Number of kids</p>
					<form>
						<select name="slct" id="earlyDropdown" data-level="early" onChange={handlePriceChange}>
							<option>1-10</option>
							<option>11-20</option>
							<option>21-35</option>
							<option>36-50</option>
							<option>51+</option>
						</select>

						<div className="radios" style={{display: 'none'}}>
							<div>
								<input
									type="radio"
									name="early"
									className="early"
									id="earlyStandard"
									value="standard"
									checked={selectedEarlyValue === "standard"}
									onChange={handleRadioChange}
								/>
								<label htmlFor="earlyStandard">Standard</label>
							</div>
						</div>
					</form>
					<h2><span className="dollar">$</span><span className="price" id="earlyPrice">{ getPrices().early['standard'][0] }</span></h2>
					<p>Annually</p>
				</div>
			</div>
			<div className="tile">
				<div className="image full">
					<img src={Children} alt="group of children looking at tablets" />
				</div>
				<div className="content">
					<h3>Children</h3>
					<p>Number of kids</p>
					<form>
						<select name="slct" id="childrenDropdown" data-level="children" onChange={handlePriceChange}>
							<option>1-25</option>
							<option>26-50</option>
							<option>51-75</option>
							<option>76-100</option>
							<option>101+</option>
						</select>

						<div className="radios">
							<div>
								<input
									type="radio"
									name="children"
									className="children"
									id="childrenStandard"
									value="standard"
									checked={selectedChildrenValue === "standard"}
									onChange={handleRadioChange}
								/>
								<label htmlFor="childrenStandard">Standard</label>
							</div>

							<div>
								<input
									type="radio"
									name="children"
									className="children"
									id="childrenDeluxe"
									value="deluxe"
									checked={selectedChildrenValue === "deluxe"}
									onChange={handleRadioChange}
								/>
								<label htmlFor="childrenDeluxe">Deluxe (SHD+)</label>
							</div>
						</div>
					</form>
					<h2><span className="dollar">$</span><span className="price" id="childrenPrice">{ getPrices().children['standard'][0] }</span></h2>
					<p>Annually</p>
				</div>
			</div>
			<div className="tile">
				<div className="image full">
					<img src={Youth} alt="group of youths reading" />
				</div>
				<div className="content">
					<h3>Youth</h3>
					<p>Number of kids</p>
					<form>
						<select name="slct" id="youthDropdown" data-level="youth" onChange={handlePriceChange}>
							<option>1-10</option>
							<option>11-20</option>
							<option>21-35</option>
							<option>36-50</option>
							<option>51+</option>
						</select>

						<div className="radios" style={{display: 'none'}}>
							<div>
								<input
									type="radio"
									name="youth"
									className="youth"
									id="youthStandard"
									value="standard"
									checked={selectedYouthValue === "standard"}
									onChange={handleRadioChange}
								/>
								<label htmlFor="youthStandard">Standard</label>
							</div>
						</div>
					</form>
					<h2><span className="dollar">$</span><span className="price" id="youthPrice">{ getPrices().youth['standard'][0] }</span></h2>
					<p>Annually</p>
				</div>
			</div>
		</div>
	);
}

export default Pricing;